import { UnstyledListWithIcon } from "components/UnstyledListWithIcon";
import type { UnstyledListWithIconProps } from "components/UnstyledListWithIcon";
import type { ReactStoryblokComponent } from "types/storyblok";

export const UnstyledListWithIconAdapter = ({
  blok: { items, itemsSpacing },
  sbEditable,
}: ReactStoryblokComponent<UnstyledListWithIconProps>) => (
  <UnstyledListWithIcon sbEditable={sbEditable} items={items} itemsSpacing={itemsSpacing} />
);
